import { Api } from '@/services/Api';

export default {
     /*  1. Get all data */
    getDiagnoseDetailsByCriteria(body = { keyword: '' }) {
        return Api().post('/DiagnoseDetails/GetDiagnoseDetailsByCriteria', body)
    },
     /*  2. Get one column */
    getDiagnosisInformation(id) {
        return Api().get(`/DiagnoseDetails/${id}`);
    },
     /*  3. Create one column */
    saveDiagnosisDetailsInformation(body) {
        return Api().post(`/DiagnoseDetails`, body);
    },
    /*  4. Delete one or more columns */
    deleteDiagnoseDetails(diagnoseDetailsObj) {
        return Api().post(`/DiagnoseDetails/DeleteDiagnoseDetails`, diagnoseDetailsObj);
    },
    /*  5. post one or more columns */
    postDiagnosisInformation(diagnoseDetailsObj) {
        return Api().post(`/DiagnoseDetails/PostDiagnoseDetails`, diagnoseDetailsObj);
    }
}